import React from 'react';
import {SitePages} from "./SitePages";
import "./fonts/fonts.css"
import FrontPage from "./pages/front_page";
import NavigationPage from "./pages/navigation_page";
import MicrobialSexLoops from "./pages/microbial_sex_loops/microbial_sex_loops";
import MicrobialSexVideoComic from "./pages/microbial_sex_video_comic/microbial_sex_video_comic";
import CybershoreMeditations from "./pages/cybershore_meditations/cybershore_meditations_landing_page";
import DecaySim from "./pages/decay_sim/decay_sim";
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
} from "react-router-dom";
import ErrorPage from "./router/errorPage";
import CursorPositionPopup from "./components/cursorPositionPopup";

import { BrowserView, MobileView } from 'react-device-detect';
import MobileScreen from "./MobileScreen";

const DEV = false;
const ROOT_PATH = DEV ? "" : "/works/symbiosis/";

export default function App() {
    const roota = createBrowserRouter(
        createRoutesFromElements([

            // main pages
            <Route exact path={`${SitePages.FrontPage}`} element={<FrontPage/>} errorElement={<ErrorPage/>}/>,

            // contribution pages
            <Route exact path={`${SitePages.MicrobialSexLoops}`} element={<MicrobialSexLoops/>}/>,
            <Route exact path={`${SitePages.MicrobialSexVideoComic}`} element={<MicrobialSexVideoComic/>}/>,
            <Route exact path={`${SitePages.CybershoreMeditations}`} element={<CybershoreMeditations/>}/>,
            <Route exact path={`${SitePages.DecaySim}`} element={<DecaySim/>}/>,

            // dev pages
            <Route exact path={`${SitePages.NavigationPage}`} element={<NavigationPage/>}/>,
            <Route exact path={`${SitePages.MobilePopup}`} element={<MobileScreen/>}/>,

            // fallback
            <Route path={"/*"} element={<FrontPage/>} errorElement={<ErrorPage/>}/>,
        ]), {basename: ROOT_PATH});

    return (
        <div id={"app"}>
            {DEV ? <CursorPositionPopup/> : null}
            
            <BrowserView id={"browser view"}>
                <RouterProvider router={roota}/>                
            </BrowserView>
            
            <MobileView id={"mobile view"}>
                <MobileScreen/>
            </MobileView>
        </div>
    )


}
